export const goldGradient = "linear-gradient(224deg, #FFFADD 11.07%, #FFDA79 32.21%, #FFD700 64.57%, #FFF 89.07%)";
export const silverGradient = "linear-gradient(45deg, #FFF 0%, #DFDFDF 32.29%, #A8A8A8 66.15%, #909090 100%)";
export const bronzeGradient = "linear-gradient(223deg, #E27F1F 9.63%, #BC7838 34.18%, #CA915D 59.93%, #F3DDCA 85.67%)";
